import { gql } from '@apollo/client'

import { PRIORITY_TASK_FRAGMENT } from '../fragments'

const PRIORITY_TASKS_QUERY = gql`
  query priorityTasksQuery($pagination: PaginationInput!) {
    priorityTasks(pagination: $pagination) {
      total
      result {
        ...PriorityTaskFragment
      }
    }
  }
  ${PRIORITY_TASK_FRAGMENT}
`

export default PRIORITY_TASKS_QUERY
